import { type DetailsTableItemType, type MyCollectible } from '../models';

export const getCollectiblePropertiesItems = (collectible?: MyCollectible): Array<DetailsTableItemType> =>
	collectible?.sections &&
	collectible.sections.length > 0 &&
	collectible.sections?.[0]?.attributes &&
	collectible.sections[0].attributes.length > 0
		? collectible.sections[0].attributes.map(attribute => ({
				label: attribute.label || '',
				type: 'text',
				value: attribute.value || ''
			}))
		: [];
